module.exports = {"id":"dp4_1l3q3","text":"Protecting Devices","instructions":"How can AI systems relate to cybersecurity?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.1","questionType":"PickOne","random":true,"options":[{"id":"dp4_1l3q3-a1","text":"Used in attacks and defence","score":3.7},{"id":"dp4_1l3q3-a2","text":"Used only for protection","score":1.3},{"id":"dp4_1l3q3-a3","text":"Unrelated to security","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.1/l3q3.json
// module id = 1209
// module chunks = 41